import React, { useState, useEffect } from "react";
import FilterSessionSelect from "./SessionFilter";
import FilterLegislatureSelect from "./LegislatureFilter";
import axios from "axios";
import { MDBSideNav, MDBSideNavMenu, MDBBtn, MDBIcon } from "mdb-react-ui-kit";
import MeetingTimeFilter from "./MeetingTimeFilter";
import SponsorFilter from "./SponsorFilter";
import ChamberFilter from "./ChamberFilter";
import BillFilter from "./BillFilter";
import CommitteesFilter from "./CommitteeFilter";
function FilterSidebar({
  setFilterSession,
  setFilterLegislature,
  setModeOpen,
  modeOpen,
  sidenavContent,
  // committeeType,
  // setCommitteeType,
  sessions,
  legislatures,
  activeSession,
  activeLegislature,
  filterSession,
  filterLegislature,
  setDateRange,
  selectedLegislators,
  setSelectedLegislators,
  selectedChambers,
  setSelectedChambers,
  selectedCommitteeTypes,
  setSelectedCommitteeTypes,
  selectedBills,
  setSelectedBills,
  selectedBillTypes,
  setSelectedBillTypes,
  selectedBillStatus,
  setSelectedBillStatus,
// setCommittees,
  committees,
  filteredCommittees,
  setFilteredCommittees,
  toggleOpen,
  loadingExtraData,
  selectedCommittees,
  setSelectedCommittees,
}) {
  const [typeCollapse, setTypeCollapse] = useState(false);
  const [dateCollapse, setDateCollapse] = useState(false);
  const [legislatorCollapse, setLegislatorCollapse] = useState(false);
  const [committeeFilterCollapse, setCommitteeFilterCollapse] = useState(false);
  const [chamberCollapse, setChamberCollapse] = useState(false);
  const [billCollapse, setBillCollapse] = useState(false);
  const [container, setContainer] = useState();
  const [committeeTypes, setCommitteeTypes] = useState([]);
  const [dateFilter, setDateFilter] = useState("");

  useEffect(() => {
    setContainer(sidenavContent.current);

    // Fetch committee types from API
    const fetchCommitteeTypes = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_LAWS_BACKEND_HOST}/committees/v1/committeeTypes`
        );
        setCommitteeTypes(response.data);
      } catch (error) {
        console.error("Error fetching committee types:", error);
      }
    };
    fetchCommitteeTypes();
  }, []);

  // const handleTypeChange = (type) => {
  //   setCommitteeType((prevTypes) => {
  //     if (prevTypes.includes(type)) {
  //       return prevTypes.filter((item) => item !== type);
  //     } else {
  //       return [...prevTypes, type];
  //     }
  //   });
  // };

  return (
    <MDBSideNav
      mode="side"
      open={modeOpen}
      absolute
      contentRef={container}
      className="bg-light h-100 position-fixed"
      getOpenState={(e) => setModeOpen(e)}
    >
      {loadingExtraData ? (
        <div className="text-center my-5">
          <MDBIcon icon="spinner" spin size="3x" className="text-primary" />
          <p>Loading filters...</p>
        </div>
      ) : (
        <MDBSideNavMenu>
          <div className="d-flex justify-content-between align-items-middle my-3">
            <h4 className="fw-bold">
              <MDBIcon fas icon="filter" /> Filters
            </h4>
            <MDBBtn
              className="btn-close"
              color="none"
              aria-label="Close"
              onClick={() => setModeOpen(!modeOpen)}
            />
          </div>

          {/* Standing Filter */}
          <FilterSessionSelect
            sessions={sessions}
            filterSession={filterSession}
            setFilterSession={setFilterSession}
          />

          {/* Interim Filter */}
          <FilterLegislatureSelect
            legislatures={legislatures}
            filterLegislature={filterLegislature}
            setFilterLegislature={setFilterLegislature}
          />
          {/* Type Filter */}
          {/* <MDBSideNavItem>
                      <MDBSideNavLink
                        className="accordion-button"
                        icon="angle-down"
                        shouldBeExpanded={typeCollapse}
                        onClick={() => setTypeCollapse(!typeCollapse)}
                      >
                        Type
                      </MDBSideNavLink>
                      <MDBSideNavCollapse open={typeCollapse}>
                        <li className="p-3">
                          {committeeTypes.map((type) => (
                            <MDBCheckbox
                              key={type.id}
                              label={type.description}
                              onChange={() => handleTypeChange(type.description)}
                              checked={committeeType.includes(type.description)}
                            />
                          ))}
                        </li>
                      </MDBSideNavCollapse>
                    </MDBSideNavItem> */}

          {/* Chamber Filter */}
          <ChamberFilter
            selectedChambers={selectedChambers}
            setSelectedChambers={setSelectedChambers}
            chamberCollapse={chamberCollapse}
            setChamberCollapse={setChamberCollapse}
          />
          <CommitteesFilter
            committeeFilterCollapse={committeeFilterCollapse}
            allCommittees={committees}
            setCommitteeFilterCollapse={setCommitteeFilterCollapse}
            setAllCommittees={setFilteredCommittees}
            selectedCommittees={selectedCommittees}
            setSelectedCommittees={setSelectedCommittees}
            selectedCommitteeTypes={selectedCommitteeTypes}
            setSelectedCommitteeTypes={setSelectedCommitteeTypes}
          />
          {/* Legislator Filter */}
          <SponsorFilter
            selectedLegislators={selectedLegislators}
            setSelectedLegislators={setSelectedLegislators}
            filterLegislature={filterLegislature}
            filterSession={filterSession}
            legislatorCollapse={legislatorCollapse}
            setLegislatorCollapse={setLegislatorCollapse}
          />

          {/* Bill Filter */}
          <BillFilter
            selectedBills={selectedBills}
            setSelectedBills={setSelectedBills}
            selectedBillTypes={selectedBillTypes}
            setSelectedBillTypes={setSelectedBillTypes}
            selectedBillStatus={selectedBillStatus}
            setSelectedBillStatus={setSelectedBillStatus}
            billCollapse={billCollapse}
            setBillCollapse={setBillCollapse}
            filteredCommittees={filteredCommittees}
          />

          {/* Date Filter */}
          <MeetingTimeFilter
            dateFilter={dateFilter}
            setDateFilter={setDateFilter}
            setDateRange={setDateRange}
            dateCollapse={dateCollapse}
            setDateCollapse={setDateCollapse}
          />

          {/* Reset Filter Button */}
          <div className="d-flex justify-content-center my-3">
            <MDBBtn
              color="dark"
              onClick={() => {
                setFilterSession(activeSession);
                setFilterLegislature(activeLegislature);
                // setCommitteeType([]); // Clear committee type
                setDateRange(null); // Clear date range
                setDateFilter("Future"); // Set to "All Future"
                setSelectedLegislators({ legs: [], roles: [] }); // Clear selected legislator
                setSelectedChambers([]); // Clear selected chambers
                setSelectedBills([]); // Clear selected bills
                setSelectedCommittees([]);
                setSelectedCommitteeTypes("RESET")
              }}
            >
              Clear Filter
            </MDBBtn>
            <MDBBtn onClick={toggleOpen} color="primary" className="ms-1">
              <MDBIcon fas icon="cloud-download-alt" /> Export
            </MDBBtn>
          </div>
        </MDBSideNavMenu>
      )}
    </MDBSideNav>
  );
}

export default FilterSidebar;
